import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome to Candle Co."); navigate("/"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md p-8 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))]">
        <div className="text-center mb-6">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-2">Join the glow</div>
          <h1 className="font-serif text-3xl">Create your account</h1>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <Field label="Name" v={form.name} onC={(v) => setForm((s) => ({ ...s, name: v }))} tid="register-name" />
          <Field label="Email" type="email" v={form.email} onC={(v) => setForm((s) => ({ ...s, email: v }))} tid="register-email" />
          <Field label="Password" type="password" v={form.password} onC={(v) => setForm((s) => ({ ...s, password: v }))} tid="register-password" />
          <Button data-testid="register-submit" disabled={loading} type="submit" size="lg" className="w-full rounded-full">
            {loading ? "Creating…" : "Create Account"}
          </Button>
        </form>
        <div className="text-sm text-center mt-4 text-muted-foreground">
          Already a member? <Link to="/login" data-testid="link-login" className="text-candle-terracotta font-medium">Sign in</Link>
        </div>
      </div>
    </div>
  );
}

const Field = ({ label, v, onC, type = "text", tid }) => (
  <label className="block">
    <span className="text-sm font-medium">{label}</span>
    <input required type={type} value={v} onChange={(e) => onC(e.target.value)} data-testid={tid}
      className="mt-1 w-full px-3 py-2.5 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--background))] text-sm focus:outline-none focus:ring-2 focus:ring-candle-terracotta/40" />
  </label>
);
